"use client";

import React from "react";
import Link from "next/link";
import clsx from "clsx";
import { useSuspenseQuery } from "@apollo/client";
import { GET_REGION_WISE_COUNTRIES } from "@/graphql/queries/region-wise-countries";
import { useCountryCode } from "@/hooks/useCountryCode";
import useCountryPages from "@/hooks/useCountryPages";

const CountryList = () => {
  const { data: regionCountries } = useSuspenseQuery(GET_REGION_WISE_COUNTRIES);
  const { country } = useCountryCode();
  const { countries } = useCountryPages(regionCountries?.regionWiseCountries);
  return (
    <ul className="sm:columns-7 columns-2 ">
      {countries.map((item) => (
        <React.Fragment key={item.region}>
          <li className="my-3">
            <label className="font-semi-bold">{item.region}</label>
          </li>
          {item.countries.map((rc) => (
            <li key={rc.code_slug}>
              <Link
                href={rc.url}
                className={clsx("hover:underline text-sm", {
                  "text-secondary-main": country === rc.code_slug,
                  "text-primary-light": country !== rc.code_slug,
                })}
              >
                {rc.name}
              </Link>
            </li>
          ))}
        </React.Fragment>
      ))}
    </ul>
  );
};

export default CountryList;
